import { Component } from '@angular/core';

@Component({
  selector: 'app-section-projeto-educere',
  templateUrl: './section-projeto-educere.component.html',
  styleUrls: ['./section-projeto-educere.component.scss'],
})
export class SectionProjetoEducereComponent {}
